import { getData, postData, putData, deleteData } from './index';
import { PROGRAM_ERROR, FETCH_PROGRAMS, FETCH_PROGRAM, FETCH_PROGRAMS_LIST, CREATE_PROGRAM, UPDATE_PROGRAM, DELETE_PROGRAM, UPDATE_PROGRAM_PICTURE } from './types';

//= ===============================
// PROGRAM actions
//= ===============================

export function fetchPrograms() {
  const url = '/program';
  return dispatch => getData(FETCH_PROGRAMS, PROGRAM_ERROR, true, url, dispatch);
}

export function fetchProgram(programId) {
  const url = '/program/'+programId;
  return dispatch => getData(FETCH_PROGRAM, PROGRAM_ERROR, true, url, dispatch);
}

export function getAutocompleteList(documentId) {
  let data = {documentId:documentId};
  const url = '/program/autocompleteList'
  return dispatch => postData(FETCH_PROGRAMS_LIST, PROGRAM_ERROR, true, url, dispatch,data);
}

export function createProgram() {
  var editor = JSON.parse(localStorage.getItem("user"));
  const data = {};
  data.consultantEditor = {
    firstName : editor.firstName,
    LastName : editor.lastName,
    _id : editor._id
  }

  const url = '/program';
  return dispatch => postData(CREATE_PROGRAM, PROGRAM_ERROR, true, url, dispatch, data);
}

export function createProgramForConsultant(consultant) {
  var editor = consultant
  const data = {};
  data.consultantEditor = {
    firstName : editor.firstName,
    LastName : editor.lastName,
    _id : editor._id
  }
  const url = '/program';
  return dispatch => postData(CREATE_PROGRAM, PROGRAM_ERROR, true, url, dispatch, data);
}

export function updateFieldProgram(program, programId){
  let data = { program };
  const parent = data.program.parent === "projectManager" ? data.program.parent : 'content'
  data.program.parent = data.program.parent === "projectManager" ? "" : data.program.parent
  const url = '/program/updatefield/'+ parent +'/'+programId;
  return dispatch => putData(UPDATE_PROGRAM, PROGRAM_ERROR, true, url, dispatch, data);
}

export function addFieldProgram(program, parent, programId){
  const data = { program };
  const url = '/program/addfield/'+ parent +'/'+programId;
  return dispatch => putData(UPDATE_PROGRAM, PROGRAM_ERROR, true, url, dispatch, data);
}

export function removeFieldProgram(i, parent, programId){
  const data = {
    index : i
  };
  const url = '/program/removefield/'+ parent +'/'+programId;
  return dispatch => putData(UPDATE_PROGRAM, PROGRAM_ERROR, true, url, dispatch, data);
}

export function deleteProgram(program) {
  const url = '/program/'+program;
  return dispatch => deleteData(DELETE_PROGRAM, PROGRAM_ERROR, true, url, dispatch);
}

export function validate(program, programId){
  const data = { };
  const url = '/program/validate/' + programId
  return dispatch => putData(UPDATE_PROGRAM, PROGRAM_ERROR, true, url, dispatch, data);
}


export function extractProgram(programId) {
  const url = '/program/extract/'+programId;
  return dispatch => getData(FETCH_PROGRAM, PROGRAM_ERROR, true, url, dispatch);
}

export function uploadPicture(file, programId) {
  let data = new FormData()
  data.append('file', file)
  const url = '/program/picture/'+programId;
  return dispatch => putData(UPDATE_PROGRAM_PICTURE, PROGRAM_ERROR, true, url, dispatch, data);
}
